import React from 'react';
import PropTypes from 'prop-types';
import BaseDatepicker from 'components/atoms/base-datepicker';

const DatePicker = ({
  value,
  valueChanged,
  format: customFormat,
  disabled,
}) => {
  return (
    <BaseDatepicker
      value={value}
      format={customFormat}
      disabled={disabled}
      onChange={(_, val) => valueChanged(val)}
    />
  );
};

DatePicker.propTypes = {
  value: PropTypes.string,
  format: PropTypes.string,
  valueChanged: PropTypes.func,
  disabled: PropTypes.bool,
};

export default DatePicker;
